const target = 'stat'
export default {
  allStatStoreRankTeam: {
    config: {
      url: `/${target}/allStatStoreRankTeam`,
      method: 'post'
    }
  },
  findStatStoreRankTeam: {
    config: {
      url: `/${target}/findStatStoreRankTeam`,
      method: 'post'
    }
  },
  listStatStoreRankTeam: {
    config: {
      url: `/${target}/listStatStoreRankTeam`,
      method: 'post'
    }
  },
  statList: {
    config: {
      url: `/statRankingNum/statList`,
      method: 'post'
    }
  },
  waitstatList: {
    config: {
      url: `/statWaitTime/statList`,
      method: 'post'
    }
  }
}
